<template>
    <div>
        <div class="mb-3">
            <BackButton :href="$route('user-reports')" to="den Nutzermeldungen" />
        </div>

        <div class="card">
            <div class="card-header">
                <h2 class="m-0">Nutzermeldung: {{ report.type }}</h2>
            </div>
            <div class="card-body">
                <div v-if="report.type === 'reservation'" class="row">
                    <div class="col-md-7">
                        <h5>Kunden Informationen</h5>
                        <div class="row">
                            <div class="col-md-7">
                                <i class="fas fa-envelope mr-2 text-muted" />
                                <BlacklistableEmail
                                    :is-blacklisted='isBlacklisted'
                                    suggest-reason="spam">{{ report.data.email }}
                                </BlacklistableEmail>
                                <br>
                                <i class="fas fa-phone mr-3 text-muted"></i>{{ report.data.phone }}
                            </div>
                            <div class="col-md-5">
                                <i class="fas fa-map-marker-alt mr-2 text-muted" />
                                {{ report.data.street ?? __('general.unspecified') }}<br>
                                {{ report.data.zip }} {{ report.data.city }}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-5 mt-4 mt-md-0">
                        <h5>Nachricht der gemeldeten Person an Händler</h5>
                        <p class="rounded-sm p-4" style="background: #f1f1f5; white-space: pre-wrap;">
                            {{ report.data.message ?? 'n/a' }}
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-3">
            <div class="row no-gutters">
                <div class="col-md-7">
                    <div class="card card-body">
                        <h4>
                            <i class="fas fa-reply mr-1"/>
                            Antwort an <u>{{ report.reply_to }}</u>
                        </h4>

                    </div>
                </div>
                <div class="col-md-5 pl-md-3 pt-3 pt-md-0">
                    <div class="card card-body">
                        <h4>
                            <i class="fas fa-sticky-note mr-1"/>
                            Notizen für <u>Storeplus-Mitarbeiter</u>
                        </h4>
                        <div>
                            <SaveableTextarea
                                :action="$route('user-reports.save-notes', [report.id])"
                                placeholder="Notizen"
                            >{{ report.notes }}
                            </SaveableTextarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserReportsResponse from "@components/UserReports/UserReportsResponse.vue";
import SaveableTextarea from "@components/SaveableTextarea.vue";
import BlacklistableEmail from "@components/BlacklistableEmail.vue";
import BackButton from "@components/BackButton.vue";

export default {
    components: {BackButton, BlacklistableEmail, SaveableTextarea, UserReportsResponse},

    props: {
        report: Object,
        isBlacklisted: Boolean
    }
}
</script>
